import * as React from "react";
export function SvgSpacesMastheadFile(
  props: React.SVGProps<SVGSVGElement>
): JSX.Element {
  return (
    <svg width={60} height={60} {...props}>
      <path
        d="M36 18.4c0-.4-.1-.5-.3-.7l-.4-.4-8.6-8.6-.4-.4c-.2-.2-.4-.3-.7-.3H2c-.6 0-1 .5-1 1v41c0 .4.2.7.5.9.2.1.3.1.5.1h33c.3 0 .5-.1.7-.3 0 0 .1-.1.1-.2.1-.2.2-.3.2-.5V18.4zm-5.8-4.7l4.3 4.3H26V9.4l4.2 4.3zm-4.6 5.2c.1.1.3.1.4.1h9v31H2V9h23v9c0 .5.2.8.6.9z"
        fill="#6e6f72"
      />
      <path fill="none" d="M23 37h17.5v17.4H23z" />
    </svg>
  );
}
